import { CircleHelp } from 'lucide-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';
import { HELP_BASE_PATH } from './helpCenter';
import { useHelpDrawer } from './HelpDrawer';

/** The "?" in the top bar: opens the help article for the current page. */
const HelpButton = () => {
    const { t } = useTranslation();
    const { pathname } = useLocation();
    const { openForCurrentPage } = useHelpDrawer();

    // On the help pages themselves the article is already on screen.
    if (pathname === HELP_BASE_PATH || pathname.startsWith(`${HELP_BASE_PATH}/`)) return null;

    return (
        <button
            onClick={openForCurrentPage}
            title={t('help.open_help')}
            aria-label={t('help.open_help')}
            className={'p-2 mr-1 rounded-full text-foreground/60 hover:text-foreground hover:bg-foreground/5'}
        >
            <CircleHelp className={'w-5 h-5'} />
        </button>
    );
};

export default HelpButton;
